const RUN_URL =
  "https://cors-anywhere.herokuapp.com/https://api.jdoodle.com/v1/execute";
const CLIENT_ID = "66c00979d1e364e238bf13547e4bf8ab";
const CLIENT_SECRET =
  "7427e25984e3607ac4bdfc13a797ca4137ce3bbb1da6a010307614f1db506173";

export { RUN_URL, CLIENT_ID, CLIENT_SECRET };
